import BetLimitSettingsForm from './BetLimitSettingsForm.jsx';
import { connect } from 'react-redux';

import { flat, expandExtended } from 'src/utils/flat';
import { prepareDecimalFields } from 'src/utils/format';
import { isNil } from 'lodash/fp';

import { request as getBetLimitSettings } from 'src/modules/system-settings/actions/get-bet-limit-settings';
import { request as putBetLimitSettings } from 'src/modules/system-settings/actions/put-bet-limit-settings';
import decorate from 'src/utils/decorate';

const FULL_TEXT_FIELDS = [
    'maxPayout',
    'minLineStake',
    'minTotalStake',
    'defaultRabBetLimits.maxBet',
    'defaultRabBetLimits.maxWin'
];

function mapStateToProps(state) {
    const data = state.systemSettings.getIn(['betLimitSettings', 'data']);
    const stakesInfo = !isNil(data) && data.toJS();
    const output = !isNil(data) && {
        ...stakesInfo,
        defaultSpPrice:
      !isNil(stakesInfo.defaultSpPrice.num) && !isNil(stakesInfo.defaultSpPrice.den) ?
          `${stakesInfo.defaultSpPrice.num}/${stakesInfo.defaultSpPrice.den}` :
          stakesInfo.defaultSpPrice
    };
    const dataObject = !isNil(data) && output && prepareDecimalFields(flat(output), FULL_TEXT_FIELDS);

    return {
        data: !isNil(data) ? dataObject : false,
        status: state.systemSettings.getIn(['betLimitSettings', 'state']) ?? 'IN_PROGRESS',
        // TODO: Refactor after Typescript migration
        shouldShowRABInputs: $appState.configState.config.showRABInputs,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetBetLimitSettings: () => dispatch(getBetLimitSettings()),
        onPutBetLimitSettings: (data) => {
            data = expandExtended(prepareDecimalFields(data, FULL_TEXT_FIELDS));
            dispatch(putBetLimitSettings({ data }));
        }
    };
}

export default decorate(connect(mapStateToProps, mapDispatchToProps), BetLimitSettingsForm);
